import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { casesAPI } from '@/lib/api';
import { toast } from 'sonner';

export default function AdminCaseNew() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ company_name: '', client_name: '', client_email: '', client_phone: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.company_name || !form.client_name) { toast.error('Company name and client name are required'); return; }
    setLoading(true);
    try {
      const res = await casesAPI.create(form);
      toast.success('Case created');
      navigate(`/admin/cases/${res.data.id}`);
    } catch (err) {
      toast.error('Failed to create case');
    } finally { setLoading(false); }
  };

  return (
    <div className="p-6 lg:p-8 max-w-xl mx-auto" data-testid="admin-case-new">
      <button onClick={() => navigate('/admin/cases')} className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-700 mb-4 transition-colors">
        <ArrowLeft className="w-4 h-4" /> Back to Cases
      </button>
      <h1 className="text-2xl font-bold text-slate-900 mb-6">Create New Case</h1>
      <Card>
        <CardContent className="p-6">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-xs text-slate-500 uppercase font-medium block mb-1.5">Company Name *</label>
              <Input value={form.company_name} onChange={e => setForm(f => ({ ...f, company_name: e.target.value }))} placeholder="ABC Pvt Ltd" className="h-10" data-testid="case-company-input" />
            </div>
            <div>
              <label className="text-xs text-slate-500 uppercase font-medium block mb-1.5">Client Name *</label>
              <Input value={form.client_name} onChange={e => setForm(f => ({ ...f, client_name: e.target.value }))} placeholder="Founder name" className="h-10" data-testid="case-client-input" />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="text-xs text-slate-500 uppercase font-medium block mb-1.5">Email</label>
                <Input type="email" value={form.client_email} onChange={e => setForm(f => ({ ...f, client_email: e.target.value }))} placeholder="email@example.com" className="h-10" data-testid="case-email-input" />
              </div>
              <div>
                <label className="text-xs text-slate-500 uppercase font-medium block mb-1.5">Phone</label>
                <Input value={form.client_phone} onChange={e => setForm(f => ({ ...f, client_phone: e.target.value }))} placeholder="+91 9876543210" className="h-10" data-testid="case-phone-input" />
              </div>
            </div>
            <Button type="submit" className="w-full bg-[#1e3a5f] hover:bg-[#152d4a] h-11" disabled={loading} data-testid="create-case-submit">
              {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
              Create Case
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
